import { apiConfig } from "core-lib/config/config";
import { postMethod } from "core-lib/utils/apiV2";
import { WalletBalanceData } from "../types/WalletBalance";
import { getDefaultHeaders } from "core-lib/utils/network";

export function serialize(data: any) {
  const obj: WalletBalanceData = {
    balance: data?.wallet_data?.balance ?? 0,
    isActive: !!data?.wallet_active_state,
  };
  return obj;
}

const fetchWalletBalance = async (
  body: any
): Promise<{
  response?: WalletBalanceData;
  rawData?: any;
  error?: any;
}> => {
  const url = `${apiConfig("payment")}/latest/parkplus/wallet-balance/`;
  const headers = getDefaultHeaders({
    deviceOs: true,
    deviceId: true,
    effectivePlatform: true,
    nativeAppVersion: false,
    packageName: true,
  });
  const { response, error }: any = await postMethod({
    endPoint: url,
    body: body,
    headers,
    enableErrorHandling: true,
  });
  if (response) {
    if (response?.data) {
      return {
        response: serialize(response.data),
        rawData: response.data,
      };
    } else return { error: {} };
  }
  if (error) {
    return { error };
  }
};

export default fetchWalletBalance;
